import { apiRequest, switchBaseUrl } from "../apiCall";

/**
 * Update User
 * @returns
 */
const postUpdateUser = async (params: UpdateUser): Promise<any> => {

    try {
        const respons = await apiRequest("Auth.UpdateUser", params);
        return respons.data
    } catch (error: any) {
        throw new Error(error)
    }


}

export { postUpdateUser }

type UpdateUser = {
    Gender: string,
    Mobile: string,
    Email: string,
    CareerFieldId: string,
    OtherCareerField: string,
    Password: string,
    LastName: string,
    FirstName: string,
    CustomerId: string
}
